import { motion } from "framer-motion";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { About } from "../components/About";
import { HomeProducts } from "../components/HomeProducts";
import { CalculatorCTA } from "../components/CalculatorCTA";
import { Footer } from "../components/Footer";
import { SEO } from "../components/SEO";

export default function HomePage() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-[#F5F2EA]"
    >
      <SEO
        path="/"
        title="Terrasses & Aménagements en Bambou"
        description="PROBWA, spécialiste des terrasses, bardages et parquets en bambou REBO à La Réunion. Devis gratuit, pose professionnelle, bambou densifié haute résistance. Calculateur de terrasse en ligne."
      />
      <Navbar />
      <main>
        <Hero />
        <About />
        <CalculatorCTA />
        <HomeProducts />
      </main>
      <Footer />
    </motion.div>
  );
}
